import React from "react";
import { Button, Grid } from "@mui/material";
import * as Type from "../../../../index.types";

interface IProps {
  isChanged: boolean;
  hasSelection: boolean;
  isSelectedRows: boolean;
  handleUploadCsv: () => void;
  handleOpenConfirmDialog: (type: Type.TDialogWindowTypes) => void;
  handleCopySelectedRowsToClipBoard: () => void;
}
const Actions: React.FC<IProps> = ({
  isChanged,
  hasSelection,
  isSelectedRows,
  handleUploadCsv,
  handleOpenConfirmDialog,
  handleCopySelectedRowsToClipBoard,
}) => {
  return (
    <>
      <Grid item xs={2}>
        <Button disabled={!isChanged} onClick={handleUploadCsv}>
          Upload
        </Button>
      </Grid>

      <Grid item xs={3}>
        <Button
          disabled={!hasSelection}
          color="secondary"
          onClick={() => handleOpenConfirmDialog("removeSelectedCells")}
        >
          Remove selected cells
        </Button>
      </Grid>

      <Grid item xs={3}>
        <Button
          disabled={!isSelectedRows}
          color="secondary"
          onClick={() => handleOpenConfirmDialog("removeSelectedRows")}
        >
          Remove selected rows
        </Button>
      </Grid>

      <Grid item xs={3}>
        <Button disabled={!isSelectedRows} onClick={handleCopySelectedRowsToClipBoard}>
          Copy to clipboard selected rows
        </Button>
      </Grid>
    </>
  );
};

export default Actions;
